// new-archive-model.js

import { Model } from 'backbone';
import Immutable from 'immutable';

class NewArchiveModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }


    parse(response, options)  {
        return response;
    }
}

export default NewArchiveModel;
